export default {"src":"/_next/static/media/YouTubeRounded.a12a3d56.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};